export default import.meta.ROLLUP_FILE_URL_JoDxeQ1xEKeZpTWUJ7TFQw;